import './map.scss';

const Map = () => (
  <section className="map">
    <div id="storepoint-container" data-map-id="162e18c4b5e5f4" />
  </section>
);

export default Map;
